module.exports = __webpack_public_path__ + "static/media/background-pagamentos1-mobile.86855633.jpg";